import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  IconButton, 
  Tooltip, 
  Button,
  Paper 
} from '@mui/material';
import { Timeline as TimelineIcon } from '@mui/icons-material';

const SimpleTimelineTest: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h5" gutterBottom>
          Simple Timeline Test
        </Typography>
        <Typography variant="body1" gutterBottom>
          This is a simple test to check if the timeline icon is visible.
        </Typography>
        
        <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
          <Tooltip title="Timeline Icon Test">
            <IconButton 
              size="large" 
              color="primary" 
              onClick={() => {
                console.log('Timeline icon clicked!');
                setShowModal(true);
              }}
            >
              <TimelineIcon fontSize="large" />
            </IconButton>
          </Tooltip>
          
          <Button 
            variant="contained" 
            startIcon={<TimelineIcon />}
            onClick={() => {
              console.log('Timeline button clicked!');
              setShowModal(true);
            }}
          >
            Open Timeline
          </Button>
        </Box>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Status: {showModal ? 'Modal is open' : 'Modal is closed'}
        </Typography>
      </Paper>
    </Box>
  );
};

export default SimpleTimelineTest;
